const rechargeMemberCreditsToast = (state = null, action) => {
  if (action.type === "SET_RECHARGE_MEMBER_CREDITS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_RECHARGE_MEMBER_CREDITS_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default rechargeMemberCreditsToast;
